module.exports = __webpack_public_path__ + "static/media/features_boxero.ec30a4c3.jpg";